const mangaBookLines = [
  // 1
  "Cherry blossoms fall—\nthe rival swears revenge with\nhis hair still perfect.",

  // 2
  "She slapped him again,\nbut this time he caught her hand—\n'You're late,' he whispered.",

  // 3
  "Cat girl steals the map—\nbut not before winking twice.\nPlot twist: she’s the boss.",

  // 4
  "Power level ten?\nNope. He takes off his glasses—\ntwenty thousand. Easy.",

  // 5
  "Swords clash in moonlight.\nNeither speaks of feelings but\ntheir hands both tremble.",

  // 6
  "Nosebleed from a hug—\nthe physics unclear but hey,\nwe stan true passion.",

  // 7
  "School roof, final bell—\nshe confesses with closed eyes.\nHe’s asleep. Classic.",

  // 8
  "Tentacles again.\nNo one asked for this chapter.\nYet here we all are.",

  // 9
  "Eyes wide, wind blowing—\nthe monologue is thirty\npages of drama.",

  // 10
  "The bread in her mouth\nmeans she’s late—but plot armor\nsaves her from traffic.",

  // 11
  "Villain’s tragic past:\na single raindrop falls down.\nCue piano chords now.",

  // 12
  "Training montage ends.\nHe yells the move’s name so loud,\nthe stars hear his punch.",

  // 13
  "Beach episode arc.\nAll trauma conveniently\nleft in the locker.",

  // 14
  "Cursed prince in chains—\nhe’s rude, brooding, and pretty.\nYes, I will love him.",

  // 15
  "Time traveler sighs.\nSaves her for the eighth time now.\nStill can’t confess though.",

  // 16
  "She turns into mist.\nHe yells, 'Don’t vanish on me!'\nToo late—chapter ends.",

  // 17
  "Twin brother reveals\nhe’s the clone of their cousin—\nbut born from a tree.",

  // 18
  "Glasses flash with light—\nshe knows everything and more.\nNo one asks how though.",

  // 19
  "They fight for honor,\nbut keep switching hairstyles each\ntime a page flips fast.",

  // 20
  "He trips on her scarf.\nThey fall in love mid-fall scene.\nGravity ships them.",
];

export default mangaBookLines;
    